function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0BF7C"
    },
    d: "M401.443,498.996c27.375,0,78.327-46.532,96.546-98.825l1.826-5.239l-2.577-4.915 c-1.587-3.029-4.156-6.323-7.62-9.779c-18.287-18.287-60.638-39.987-110.566-56.627c-2.697-0.896-5.146-1.442-7.27-1.647 l-6.844-0.632l-4.309,5.35c-3.746,4.651-6.605,12.39-10.871,25.95c-7.407,23.526-16.009,44.638-39.552,44.638 c-9.847,0-40.687-7.927-114.125-81.365c-73.429-73.438-81.365-104.269-81.365-114.125c0-23.543,21.12-32.145,44.638-39.552 c13.252-4.164,21.308-7.134,25.958-10.871l5.35-4.309l-0.631-6.844c-0.196-2.15-0.751-4.608-1.655-7.296 c-16.631-49.894-38.323-92.254-56.619-110.541c-3.447-3.456-6.733-6.016-9.745-7.603l-4.924-2.603l-5.265,1.835 c-52.284,18.236-98.816,69.188-98.816,96.563c0,65.451,14.071,154.675,123.921,264.516 C246.767,484.907,335.992,498.996,401.443,498.996z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M401.443,512.001c36.497,0,91.238-54.741,109.483-109.491c3.456-10.368-1.707-21.077-12.109-31.479 c-24.32-24.32-77.286-46.976-115.618-59.759c-54.741-18.244-36.497,72.994-72.994,72.994c-18.244,0-63.863-36.497-104.926-77.551 c-41.054-41.062-77.551-86.682-77.551-104.926c0-36.497,91.238-18.253,72.994-72.994c-12.783-38.34-35.43-91.29-59.759-115.61 C130.56,2.783,119.86-2.389,109.483,1.067C54.742,19.32,0,74.062,0,110.559c0,72.986,18.244,164.224,127.735,273.715 C237.219,493.748,328.457,512.001,401.443,512.001z M116.045,26.096c1.118,0.589,3.354,2.022,6.673,5.333 c16.717,16.717,37.726,58.138,53.521,105.54c0.725,2.185,0.973,3.618,1.05,4.429c-3.635,2.918-14.874,6.46-21.769,8.636 c-20.045,6.315-53.598,16.887-53.598,51.763c0,31.454,46.285,84.343,85.111,123.17s91.716,85.111,123.17,85.111 c34.884,0,45.449-33.553,51.763-53.598c2.176-6.903,5.709-18.133,8.636-21.769c0.811,0.077,2.244,0.324,4.429,1.05 c47.394,15.804,88.823,36.813,105.532,53.521c3.319,3.311,4.745,5.547,5.333,6.673c-16.811,48.247-64.188,90.24-84.454,90.24 c-62.993,0-148.949-13.662-255.471-120.175C39.467,259.508,25.805,173.543,25.805,110.55 C25.805,90.292,67.798,42.906,116.045,26.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M256,102.401v25.6c70.69,0,128,57.31,128,128h25.6C409.6,171.307,340.694,102.401,256,102.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M460.8,256.001c0-112.93-91.87-204.8-204.8-204.8v25.6c98.97,0,179.2,80.23,179.2,179.2H460.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M256,0.001v25.6c127.249,0,230.4,103.151,230.4,230.4H512C512,114.842,397.159,0.001,256,0.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.70433c6aca44eed581296abe27c255db.svg";
export { ForwardRef as ReactComponent };